import React from 'react';
import { Link } from 'react-router-dom';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import './FooterD5.scss';

const normalizePaymentName = (method) => {
  const code = String(method?.code || '').toUpperCase();
  if (code === 'MP') return 'Mercado Pago';
  if (code === 'TRANSFERENCIA') return 'Transferencia';
  if (code === 'EFECTIVO') return 'Acordar con vendedor';
  return method?.name || code || '';
};

const FooterD5 = ({
  client, envios = [], paymentMethods = [], variant = '',
}) => {
  const year = new Date().getFullYear();
  const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  const fb = client?.link_fb || '';
  const ig = client?.link_ig || '';
  const activePayments = (paymentMethods || []).filter((method) => method?.is_active !== false);
  const shippingNames = (envios || [])
    .map((envio) => envio?.name)
    .filter(Boolean)
    .slice(0, 4);

  const paymentFallback = [
    { code: 'MP', name: 'Mercado Pago' },
    { name: 'Transferencia' },
    { name: 'Efectivo / acuerdo' },
  ];

  const shippingFallback = ['Envío a domicilio', 'Retiro / acuerdo con vendedor'];

  return (
    <footer className={`d5-footer ${variant ? `d5-footer--${variant}` : ''}`.trim()} role="contentinfo">
      <div className="d5-footer__container">
        <div className="d5-footer__grid">
          <div className="d5-footer__col d5-footer__col--brand">
            <h3 className="d5-footer__brandName">{client?.name_show || client?.name || 'Tienda online'}</h3>
            {client?.description ? <p className="d5-footer__description">{client.description}</p> : null}

            <div className="d5-footer__social">
              {fb ? (
                <a href={fb} aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                  <FacebookIcon />
                </a>
              ) : null}
              {ig ? (
                <a href={ig} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                  <InstagramIcon />
                </a>
              ) : null}
            </div>
          </div>

          <div className="d5-footer__col">
            <h3 className="d5-footer__title">Comprar</h3>
            <ul className="d5-footer__list">
              <li><Link to="/productos">Productos</Link></li>
              <li><Link to="/ofertas">Ofertas</Link></li>
              <li><Link to="/preguntas-frecuentes">Preguntas frecuentes</Link></li>
              <li><Link to="/contacto">Contacto</Link></li>
            </ul>
          </div>

          <div className="d5-footer__col">
            <h3 className="d5-footer__title">Métodos de pago</h3>
            <div className="d5-footer__badges" aria-label="Métodos de pago disponibles">
              {(activePayments.length ? activePayments : paymentFallback).slice(0, 5).map((method) => (
                <span className="d5-footer__badge" key={method?.id || method?.code || method?.name}>
                  {normalizePaymentName(method)}
                </span>
              ))}
            </div>
            <p className="d5-footer__microcopy">Pagos seguros y confirmación del pedido desde la tienda.</p>
          </div>

          <div className="d5-footer__col">
            <h3 className="d5-footer__title">Envíos y atención</h3>
            <div className="d5-footer__badges d5-footer__badges--shipping">
              {(shippingNames.length ? shippingNames : shippingFallback).map((name) => (
                <span className="d5-footer__badge" key={name}>{name}</span>
              ))}
            </div>
            {client?.phone ? <p className="d5-footer__microcopy">Consultas: {client.phone}</p> : null}
          </div>
        </div>

        <div className="d5-footer__trust" aria-label="Beneficios de compra">
          <span><i className="fa fa-lock" aria-hidden="true" /> Compra protegida</span>
          <span><i className="fa fa-credit-card" aria-hidden="true" /> Pagos online y manuales</span>
          <span><i className="fa fa-truck" aria-hidden="true" /> Gestión de envíos</span>
        </div>

        <div className="d5-footer__bottom">
          <p className="d5-footer__copy">
            &copy; {year} &middot; Derechos reservados por{' '}
            <a
              href="https://info.jaypionba.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="d5-footer__brand"
            >
              Jaypion
            </a>
          </p>

          <button
            className="d5-footer__totop"
            onClick={scrollToTop}
            type="button"
            aria-label="Ir al inicio"
          >
            <span>IR AL INICIO</span>
            <i className="fa fa-arrow-up" aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default FooterD5;
